angular.module('filters.rawHtml', []).filter('rawHtml', ['$sce', function($sce){
  return function(val) {
    return $sce.trustAsHtml(_.unescape(val));
  };
}]);



// WEBPACK FOOTER //
// ./client/src/common/filters/rawHtml.js